import { Button, Col, Flex, Form, InputNumber, Row, Switch, Typography, TimePicker, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateNotificationSettings } from '../../redux/actions/notificationActions';
import { NOTIFICATION_UPDATE_FAILED, NOTIFICATION_UPDATE_SUCCESS } from '../../constants/message';
import get from 'lodash/get';
import mapValues from 'lodash/mapValues';
import { dayjsToMinutes, minutesToDayjs } from '../../utilities/helpers';

const { Text } = Typography;

const InjectionMouldingForm = ({ initialValues, filter, getNotifications }) => {
    const [noficationForm] = Form.useForm();
    const [isFormTouched, setIsFormTouched] = useState(false);
    
    const dispatch = useDispatch();
 const processInitialValues = (data) => {
        if (!data || Object.keys(data).length === 0) {
            return {
                paused: false,
                settings: {
                    '1': { paused: false, frequency: minutesToDayjs(10) },
                    '2': { paused: false, frequency: minutesToDayjs(10) },
                    '3': { paused: false, frequency: minutesToDayjs(10) },
                    '4': { paused: false, frequency: minutesToDayjs(10) },
                    '5': { paused: false, frequency: minutesToDayjs(10), alert_difference_percent: 10 },
                    '6': { paused: false, frequency: minutesToDayjs(10), alert_difference_percent: 10 },
                },
            };
        }

        const processedSettings = mapValues(get(data,'settings'), (setting) => {
            const newSetting = { ...setting };
            newSetting.frequency = minutesToDayjs(get(newSetting, 'frequency', 10));
            newSetting.alert_difference_percent = get(newSetting, 'alert_difference_percent', 10);
            return newSetting;
        });

        return {
            ...data,
            settings: processedSettings,
        };
    };

    
    const updateNotification = (payload) => {
        dispatch(updateNotificationSettings(get(filter, 'company.id'), payload))
        .then(() => {
            message.success(NOTIFICATION_UPDATE_SUCCESS);
            getNotifications();
        })
        .catch(() => {
            message.error(NOTIFICATION_UPDATE_FAILED);
        });
    };
    
    const onFinish = (values) => {
        const payload = { 
            type_id: get(filter, 'templateType'), 
            paused: get(values, "paused"), 
            settings: { ...get(values,'settings') } 
        };
        
        payload.settings = mapValues(get(payload,'settings'), (setting, key) => {
            const updatedSetting = { ...setting };
            
            updatedSetting.frequency = dayjsToMinutes(get(updatedSetting,'frequency'));
            return updatedSetting;
        });
        
        updateNotification(payload);
        setIsFormTouched(false); 
    };
    
    const onValuesChange = () => {
        setIsFormTouched(noficationForm.isFieldsTouched());
    };
    
    useEffect(() => {
        const processedData = processInitialValues(initialValues);
        noficationForm.setFieldsValue(processedData);
        setIsFormTouched(false);
    }, [initialValues, noficationForm]);
    return (
        <div>
            <Form
                form={noficationForm}
                className='w-full md:w-[75%] pt-6'
                layout='vertical'
                initialValues={{
                    paused: get(initialValues, 'paused')||false,
                    settings: {
                        '1': {
                            paused: get(initialValues, ['settings', '1', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '1', 'frequency'], 10))||10,
                        },
                        '2': {
                            paused: get(initialValues, ['settings', '2', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '2', 'frequency'], 10))||10,
                        },
                        '3': {
                            paused: get(initialValues, ['settings', '3', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '3', 'frequency'], 10))||10,
                        },
                        '4': {
                            paused: get(initialValues, ['settings', '4', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '4', 'frequency'], 10))||10,
                        },
                        '5': {
                            paused: get(initialValues, ['settings', '5', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '5', 'frequency'], 10))||10,
                            alert_difference_percent: get(initialValues, ['settings', '5', 'alert_difference_percent']||10, 10),
                        },
                        '6': {
                            paused: get(initialValues, ['settings', '6', 'paused'])||false,
                            frequency: minutesToDayjs(get(initialValues, ['settings', '6', 'frequency'], 10))||10,
                            alert_difference_percent: get(initialValues, ['settings', '6', 'alert_difference_percent']||10, 10),
                        },
                    },
                }}
                onFinish={onFinish}
                onValuesChange={onValuesChange}
            >
                <Flex vertical>
                    <Row gutter={[16, 16]} className='mb-4 border border-bottom-2'>
                        <Col xs={6}>
                            <Text strong>Type</Text>
                        </Col>
                        <Col xs={6}>
                            <Text strong>Paused</Text>
                        </Col>
                        <Col xs={6}>
                            <Text strong>Frequency</Text>
                        </Col>
                        <Col xs={6}>
                            <Text strong>Deviation percent</Text>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Machine Off</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '1', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '1', 'frequency']} rules={[{ required: true, message: "Please enter Frequency Time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' placeholder='Frequency' minuteStep={10} style={{ width: '100%' }} 
                                 />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Machine Idle</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '2', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '2', 'frequency']} rules={[{ required: true, message: "Please enter Frequency Time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' placeholder='Frequency' minuteStep={10} style={{ width: '100%' }}  />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Shift Setting Pending</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '3', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '3', 'frequency']} rules={[{ required: true, message: "Please enter Frequency Time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' minuteStep={10} placeholder='Frequency' style={{ width: '100%' }}  />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Gateway offline</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '4', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '4', 'frequency']} rules={[{ required: true, message: "Please enter Frequency Time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' minuteStep={10} placeholder='Frequency' style={{ width: '100%' }} 
                                 />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Cycle Time Mismatched</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '5', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '5', 'frequency']} rules={[{ required: true, message: "Please enter Frequency Time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' placeholder='Frequency' minuteStep={10} style={{ width: '100%' }} 
                                 />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '5', 'alert_difference_percent']} rules={[{required:true, type: 'number', min: 10, max: 100,message: "Please enter Deviation Percent" }]}>
                                <InputNumber size="small" addonAfter='%' style={{ width: '100%' }} placeholder='Deviation percent' 
                                 />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Production Mismatched</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '6', 'paused']} valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '6', 'frequency']} rules={[{ required: true, message: "Please enter frequency time" }]}>
                                <TimePicker size="small" showNow={false} format='HH:mm' placeholder='Frequency' minuteStep={10} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name={['settings', '6', 'alert_difference_percent']} rules={[{required:true, type: 'number', min: 10, max: 100, message:"Please enter Alert Difference percent" }]}>
                                <InputNumber size='small' addonAfter='%' placeholder='Deviation percent' style={{ width: '100%' }}/>
                            </Form.Item>
                        </Col>
                    </Row>
                     <Row className='items-center mb-4' gutter={[16, 16]}>
                        <Col xs={6}>
                            <Text>Pause All Notifications</Text>
                        </Col>
                        <Col xs={6}>
                            <Form.Item name="paused" valuePropName='checked'>
                                <Switch size="small" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Flex>
                <Form.Item className='flex mt-4'>
                    <Button
                        type='primary'
                        htmlType='submit'
                        disabled={!isFormTouched}
                    >
                        Save
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default InjectionMouldingForm;